import _ from 'lodash'
import { useState } from 'react'
export {
  getBillingCycleDateValue,
  parseBillingCycleDateValue,
  getPrettyBillingRange,
  switchy,
} from '@evergreen/shared/utils'

export const justDigits = (s = '') => s.toString().replace(/\D+/g, '')

export const formatPhone = str => {
  let n = str.replace(/\D/g, '')

  return `${n.slice(0, 3)}-${n.slice(3, 6)}-${n.slice(6, 10)}`
}

export const formatNumber = str => str.replace(/[^0-9.-]/g, '')

export const toggleInArray = (arr, val) =>
  _.includes(arr, val) ? _.filter(arr, v => v !== val) : arr.concat(val)

// thanks https://stackoverflow.com/questions/41607804/promise-each-without-bluebird
export const forEachPromise = function (arr, fn) {
  // invalid input
  if (!Array.isArray(arr))
    return Promise.reject(new Error('Non array passed to each'))
  // empty case
  if (arr.length === 0) return Promise.resolve()
  return arr.reduce((prev, cur) => {
    return prev.then(() => fn(cur))
  }, Promise.resolve())
}

export const copyToClipboard = text => {
  let textarea = document.createElement('textarea')
  textarea.value = text
  document.body.appendChild(textarea)
  textarea.select()
  document.execCommand('copy')
  document.body.removeChild(textarea)
}

export let useArrayToggleState = (initialState = []) => {
  let [state, setState] = useState(initialState)
  let toggle = value =>
    setState(prev =>
      prev.includes(value) ? prev.filter(v => v !== value) : prev.concat(value)
    )
  return [state, toggle, setState]
}

export let useSetState = initialState => {
  let [state, set] = useState(initialState)
  let setState = update => set(prev => ({ ...prev, ...update }))
  return [state, setState]
}

export let useDeepState = initialState => {
  // not exactly performant.  Actually it's lots slower on huuuge state, but easier to manage updates for smaller nested stuff
  let [state, setState] = useState(initialState)
  let update = (pathOrUpdateFn, value) =>
    // notice you can pass a function to update existing value at the path
    setState(prev => {
      if (_.isFunction(pathOrUpdateFn)) {
        return pathOrUpdateFn(prev)
      }
      let originalPath = pathOrUpdateFn
      // if you do a subPath thing like below, and the array
      // is a within the array, it won't work, unless you flatten() like below
      // <Component
      //   update={(subPath, value) =>
      //     update(['performanceReviewFactors', subPath], value)
      //   }
      // />
      let path = _.isArray(originalPath)
        ? _.flatten(originalPath)
        : originalPath
      let prevClone = _.cloneDeep(prev)
      let newValue = _.isFunction(value) ? value(_.get(prevClone, path)) : value
      let newState = _.set(prevClone, path, newValue)

      return newState
    })

  return [state, update, setState]
}
